import api from './axios';

export interface UserResponse {
  id: number;
  username: string;
  email: string;
  fullName: string;
  role: string;
  active: boolean;
  createdAt: string;
}

export interface UserRequest {
  username: string;
  password: string;
  email: string;
  fullName: string;
  role: string;
  active: boolean;
}

export const getUsers = () => api.get<UserResponse[]>('/admin/users').then(r => r.data);
export const createUser = (data: Partial<UserRequest>) => api.post<UserResponse>('/admin/users', data).then(r => r.data);
export const updateUser = (id: number, data: Partial<UserRequest>) => api.put<UserResponse>(`/admin/users/${id}`, data).then(r => r.data);
export const toggleUserActive = (id: number) => api.patch(`/admin/users/${id}/toggle`);
